import { GET_INQUIRY_BY_ID, INQUIRY_LIST, UPDATE_INQUIRY_STATUS } from "./apiRoutes";
import { authData } from "./Service";

export const listOfInquiriesApi = async (data) => {
  const response = await authData.post(INQUIRY_LIST, data);
  return response?.data;
};

export const getInquiryByIdApi = async (data) => {
  const response = await authData.post(GET_INQUIRY_BY_ID, data);
  return response?.data;
};

export const updateInquiryStatusApi = async (data) => {
  const response = await authData.put(UPDATE_INQUIRY_STATUS, data);
  return response?.data;
};
